import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import './AdAllMovies.css'
import loadgif from '../../Resources/loading2.gif'
import BASE_URL from '../../constant';



function AdAllMovies() {

  const [moviedata, setMovieData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(()=>{

    axios.get(`${BASE_URL}/bookmyshow/api/v1/movie`)
    .then(res=>{
      setMovieData(res.data);
      setLoading(false);
    })
    .catch(err => {console.log(err.message);
    setMessage("Some internal error occurred. Try again later :( ");
    setLoading(false);
    });

    setTimeout(() => {
      setMessage("")
    }, 3000);

  },[]);

  const handleDelete = (movieId)=>{
    axios.delete(`${BASE_URL}/bookmyshow/api/v1/movie/${movieId}`)
    .then(res => {
      console.log(res.data.message);
    })
    .catch(err => {
      console.log(err.message);
      setMessage("Movie has been deleted successfully.")
    })
    setTimeout(() => {
      setMessage("")
    }, 3000);
  }


  return (
    <div>

    <div className="err-message">{message}</div>

      { loading ? <div className='gifContainer'>
        <img src={loadgif} alt="Loading..." /><div>Loading theatre details...</div>
      </div> : <div className='admoviePoster-container'>
      <Link to="/admin/addmovie" className='addmovieBtn admoviePoster'>
        <span>+</span> Add Movie
      </Link>
      {
          moviedata && moviedata.map((movie, index)=>{
            return (<div key={index} className='admoviePoster'>
            <img src={movie.posterImage.url} alt="poster1" className='adposterimg' />
            <div className="admovie-name">
              {movie.name}
            </div>
            <div className="adBtns">
              <button className="adbtn del" onClick={()=>{handleDelete(movie._id)}}>
                <i className='fa-solid fa-trash'></i> &nbsp;Delete
              </button>
              <button className="adbtn upd">
                <i className='fa-solid fa-pencil'></i> &nbsp;Update
              </button>
            </div>
          </div>)
          })
        }
      </div>}
    </div>
  )
}

export default AdAllMovies
